import { listCustomizations } from './List';
import { chipCustomizations } from './Chip';
import { dataGridCustomizations } from './DataGrid';
import { iconCustomizations } from './Icon';

/**
 * Merged customizations for every "data-display" MUI component in the
 * app. Consumed by the parent aggregator at Customizations/index.jsx.
 *
 * Add a new component here by:
 *   1. Creating <NewComponent>.jsx in this folder
 *   2. Exporting a `newComponentCustomizations` object of shape
 *      `{ MuiNewComponent: { styleOverrides|defaultProps|variants } }`
 *   3. Spreading it into the export below
 *
 * The snapshot test at dataDisplay.test.jsx verifies every MUI
 * component key is present after the merge, so a missing import here
 * fails CI.
 *
 * Note: `iconCustomizations` here refers to MUI's font-based <Icon> —
 * distinct from the SIBLING file Customizations/icon.jsx which
 * overrides MuiSvgIcon. Both coexist because they target different
 * MUI components (MuiIcon vs MuiSvgIcon).
 */
export const dataDisplayCustomizations = {
  ...listCustomizations,
  ...chipCustomizations,
  ...dataGridCustomizations,
  ...iconCustomizations,
};
